export default {
    WALKTHROUGH: 'WALKTHROUGH',
    LIST_WITH_ICONS: 'LIST_WITH_ICONS',
    SIMPLE_LIST: 'SIMPLE_LIST',
};
